// extracted by mini-css-extract-plugin
export default {"Terms":"Terms_Terms__iFEuF"};